import sentryInit from '@src/slide/infrastructure/module/dependent/report/js-error/sentry';
import { TdwReport } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';

export function initReport(appEntryType: AppEntryType) {
    const options = { appEntryType };
    sentryInit(options);
    TdwReport.init(options);
}
